module.exports = __webpack_public_path__ + "img/type_curtain_link.cc8159ce.jpg";